export default {
    investmentDuration: 10,
    assumedReturn: 0.04,
    assumedReturnCallMoney: 0,
};
